import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgList(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M29.25 9.25004L8.75 9.25004V6.75004L29.25 6.75004V9.25004Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.25 9.25012L2.75 9.25L2.75 6.75L6.25 6.75012V9.25012Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M29.25 17.25L8.75 17.25L8.75 14.75L29.25 14.75V17.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.25 17.2501L2.75 17.25L2.75 14.75L6.25 14.7501V17.2501Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M29.25 25.25L8.75 25.25V22.75L29.25 22.75V25.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.25 25.2501L2.75 25.25L2.75 22.75L6.25 22.7501L6.25 25.2501Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
